import Grid from '@mui/material/Grid'

import type { FilterOption, GroupedFilterOption } from '@models/Filter'

import { DashboardCard } from '../../../aansluiting/dashboard/components/DashboardCard'
import { KpiButton } from '../../../aansluiting/dashboard/components/KpiButton'
import {
  SubprocesStatusHoofdleiding,
  SubprocesTypes,
} from '../../../entity/subprocessen/types/Subproces'
import { getStatusLabelForType } from '../../../entity/subprocessen/util/subproces-util'
import type { ProcesstapHoofdleiding } from '../../../status/types/ProcesstapHoofdleiding'
import { StyledExpandCard } from '../../../theme/components/StyledExpandCard'
import { initialState } from '../../subprocessen/services/searchSubprocessen'
import { useSubprocessen } from '../hooks/useSubprocessen'

import { SubprocesWerklijstenFilters } from './SubprocesFilters'

interface Props {
  filterOptions: {
    coordinerenden: string[]
    labels: FilterOption[]
    hoofdleiding: {
      gebieden: FilterOption[]
      netbeheerders: string[]
      verantwoordelijken: GroupedFilterOption[]
      typeWerkTypes: string[]
      gemeenten: string[]
    }
    processtappen: ProcesstapHoofdleiding[]
  }
  onClickTile: (query: any, url: string) => void
}

export const Subprocessen = ({ onClickTile, filterOptions }: Props) => {
  const {
    data: { subprocessen },
    filters,
    initialFilters,
    onChangeFilters,
    onReset,
    onRefresh,
  } = useSubprocessen()

  const groupedCodes: Record<
    string,
    { code: string; count: number; red: number; amber: number; green: number }[]
  > = {}

  // label komt vanuit de backend als het 'type' subproces
  subprocessen.forEach((x) => {
    if (!groupedCodes[x.label]) {
      groupedCodes[x.label] = []
    }

    groupedCodes[x.label].push(x)
  })

  // een soort vertaalslag omdat de subprocesTile de aansluiting route hard-coded heeft.
  const onClick = (type, status, kpi?: 'red' | 'amber' | 'green') => {
    const query = {
      filters: {
        ...initialState.query.filters,
        ...filters,
        type: [{ code: type, label: SubprocesTypes[type] }],
        status: [{ code: status, label: getStatusLabelForType(type, status) }],
        due: false,
      },
      page: initialState.query.page,
      sort: initialState.query.sort,
    }

    if (kpi) {
      query.filters.kpi = kpi
    }

    onClickTile(query, '/hoofdleiding/subprocessen')
  }

  return (
    <>
      <SubprocesWerklijstenFilters
        filters={filters}
        initialFilters={initialFilters}
        onChange={onChangeFilters}
        onRefresh={onRefresh}
        onReset={onReset}
        filterOptions={filterOptions}
      />
      {Object.entries(groupedCodes).map(([type, entries]) => {
        return (
          <StyledExpandCard title={SubprocesTypes[type]} key={type}>
            <Grid container spacing={2}>
              {entries.map(({ code, count, red, amber, green }) => (
                <Grid key={code}>
                  <DashboardCard
                    key={code}
                    onClick={() => onClick(type, code)}
                    label={SubprocesStatusHoofdleiding[code]}
                    count={count}
                    actions={
                      <>
                        {red > 0 && (
                          <KpiButton
                            color={'red'}
                            count={red}
                            onClick={(e) => {
                              e.stopPropagation()
                              onClick(type, code, 'red')
                            }}
                          />
                        )}
                        {amber > 0 && (
                          <KpiButton
                            color={'amber'}
                            count={amber}
                            onClick={(e) => {
                              e.stopPropagation()
                              onClick(type, code, 'amber')
                            }}
                          />
                        )}
                        {green > 0 && (
                          <KpiButton
                            color={'green'}
                            count={green}
                            onClick={(e) => {
                              e.stopPropagation()
                              onClick(type, code, 'green')
                            }}
                          />
                        )}
                      </>
                    }
                  />
                </Grid>
              ))}
            </Grid>
          </StyledExpandCard>
        )
      })}
    </>
  )
}
